import { render, staticRenderFns } from "./activitiesPage.vue?vue&type=template&id=3b4855ac&scoped=true"
import script from "./activitiesPage.vue?vue&type=script&lang=js"
export * from "./activitiesPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b4855ac",
  null
  
)

export default component.exports